<script lang="ts" setup>
import { onMounted, reactive } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import Paginador from "@/components/Paginador/Index.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";
import * as service from "@/services/logsService";
import { fdataHora } from "@/utils/funcoes";

const controle = reactive({
  filtros: {
    usuarioId: null,
    clienteId: null,
    pesquisar: null,
    dataInicio: null,
    dataFim: null,
    paginaAtual: 1,
    tamanhoPagina: 10,
  } as service.Filtros,
  itens: [] as service.Log[],
  totalRegistros: 0,
  status: "",
  erro: "",
});

onMounted(() => {
  pesquisar();
});

function pesquisar() {
  controle.status = "Pesquisando...";
  controle.erro = "";
  service.obter(controle.filtros)
    .then(r => {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
      controle.status = "";
    })
    .catch(e => {
      controle.erro = e.message || String(e);
      controle.status = "";
    });
}

function corLinha(tipo: string) {
  if (tipo === "Erro") return "text-danger";
  if (tipo === "LogUsuario") return "text-primary";
  return "";
}
</script>

<template>
  <BreadCrumb PageTitle="Logs do Sistema" SubTitle="Auditoria" />

  <Notificacao :erro="controle.erro" @limparErro="controle.erro = ''" :progresso="controle.status"
    @limparProgresso="controle.status = ''" />

  <div class="card mb-2">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-3">
          <label>Pesquisar (Local ou Descrição)</label>
          <input type="text" class="form-control form-control-sm" placeholder="Qualquer parte do texto..."
            v-model="controle.filtros.pesquisar" @input="pesquisar" />
        </div>

        <div class="col-6 col-md-3">
          <label>Cliente</label>
          <AutoCompleteClientes v-model="controle.filtros.clienteId" @selected="pesquisar" />
        </div>

        <div class="col-6 col-md-3">
          <label>Usuário</label>
          <DropdownUsuarios v-model="controle.filtros.usuarioId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Data Início</label>
          <input type="date" class="form-control form-control-sm" v-model="controle.filtros.dataInicio" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Data Fim</label>
          <input type="date" class="form-control form-control-sm" v-model="controle.filtros.dataFim" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <a class="btn btn-primary btn-sm mt-4" @click="pesquisar">
            <i class="fa fa-search me-1"></i> Pesquisar
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="mb-1 text-muted f12px">Total: {{ controle.totalRegistros }} registro(s)</div>

      <div class="table-responsive">
        <table class="table table-sm table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th class="text-nowrap">Data</th>
              <th class="text-nowrap">Tipo</th>
              <th>Usuário</th>
              <th>Cliente</th>
              <th>Empresa</th>
              <th>Local</th>
              <th>Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in controle.itens" :key="item.id">
              <td class="text-nowrap">{{ fdataHora(item.data) }}</td>
              <td class="text-nowrap" :class="corLinha(item.tipo)">{{ item.tipo }}</td>
              <td>{{ item.usuarioNome ?? "-" }}</td>
              <td>{{ item.clienteNome ?? "-" }}</td>
              <td>{{ item.empresaNome ?? "-" }}</td>
              <td>{{ item.local ?? "-" }}</td>
              <td>{{ item.descricao }}</td>
            </tr>
            <tr v-if="!controle.itens.length && !controle.status">
              <td colspan="7" class="text-center text-muted">Nenhum log encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col-md-12">
          <Paginador class="float-end" :paginaAtual="controle.filtros.paginaAtual"
            :tamanhoPagina="controle.filtros.tamanhoPagina" :totalRegistros="controle.totalRegistros"
            @on-change="(el: any) => {
              controle.filtros.paginaAtual = el.paginaAtual;
              controle.filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar();
            }" />
        </div>
      </div>
    </div>
  </div>
</template>
